var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-g-icon--favorite-icon",on:{"click":_vm.handleClick}},[_c('MaterialIcon',{staticClass:"c-g-icon--favorite-icon__icon",class:{
      'is-active': _vm.isFavorited,
      'is-active-animation': _vm.isActiveAnimation,
    },attrs:{"icon-type":_vm.iconType.FILLED,"icon-name":_vm.isFavorited ? 'bookmark' : 'bookmark_border'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }